module.exports = __webpack_public_path__ + "static/WEDDING E&M-346-bdb8e164e3aef01f088aeeb6bd76648d.jpg";